import { render } from "./CompanyCustomAnswersCard.vue?vue&type=template&id=2c4f0ada&scoped=true"
import script from "./CompanyCustomAnswersCard.vue?vue&type=script&lang=js"
export * from "./CompanyCustomAnswersCard.vue?vue&type=script&lang=js"

import "./CompanyCustomAnswersCard.vue?vue&type=style&index=0&id=2c4f0ada&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4f0ada"]])

export default __exports__